module.exports = __webpack_public_path__ + "img/home-sell.74d636a6.jpg";